// ----------------------------------------------------------------------

const account = {
  displayName: 'Deepak Pateriya',
  email: 'deepak.patairiya@phonato.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg',
  logoURL: '/static/mock-images/logos/',
  faviconURL: '/favicon/',
};

export default account;
